'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useRef } from 'react';
import { useExplore } from './ExploreProvider';
import { SearchAutofill } from './SearchAutofill';

/**
 * Standalone search input component - just the input field with search icon
 * Used by ExploreHeader and can be composed into other layouts
 */
export function SearchInput(t0) {
  const $ = _c(56);
  const {
    placeholder: t1,
    className: t2,
    searchClass: t3,
    serchInputClass: t4,
    id: t5
  } = t0;
  const placeholder = t1 === undefined ? "by Heart, Artist, Location..." : t1;
  const className = t2 === undefined ? "" : t2;
  const searchClass = t3 === undefined ? "" : t3;
  const serchInputClass = t4 === undefined ? "" : t4;
  const id = t5 === undefined ? "" : t5;
  const {
    searchQuery,
    search,
    setSearchQuery,
    clearSearch,
    commitSearch,
    isLoading,
    filters,
    filterMarkers,
    initialMarkers,
    setMapCenter,
    setMapZoom
  } = useExplore();
  const [inputValue, setInputValue] = useState(searchQuery);
  const [isAutofillOpen, setIsAutofillOpen] = useState(false);
  const containerRef = useRef(null);
  let t6;
  let t7;
  if ($[0] !== searchQuery) {
    t6 = () => {
      setInputValue(searchQuery);
    };
    t7 = [searchQuery];
    $[0] = searchQuery;
    $[1] = t6;
    $[2] = t7;
  } else {
    t6 = $[1];
    t7 = $[2];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      const handleClickOutside = function handleClickOutside(event) {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
          setIsAutofillOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    };
    t9 = [];
    $[3] = t8;
    $[4] = t9;
  } else {
    t8 = $[3];
    t9 = $[4];
  }
  useEffect(t8, t9);
  let t10;
  if ($[5] !== inputValue || $[6] !== search) {
    t10 = e => {
      e.preventDefault();
      if (inputValue.trim()) {
        search(inputValue);
      }
    };
    $[5] = inputValue;
    $[6] = search;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const handleSubmit = t10;
  let t11;
  if ($[8] !== setSearchQuery) {
    t11 = e_0 => {
      const value = e_0.target.value;
      setInputValue(value);
      setSearchQuery(value);
      setIsAutofillOpen(value.trim().length > 0);
    };
    $[8] = setSearchQuery;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const handleInputChange = t11;
  let t12;
  if ($[10] !== inputValue) {
    t12 = () => {
      if (inputValue.trim().length > 0) {
        setIsAutofillOpen(true);
      }
    };
    $[10] = inputValue;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const handleFocus = t12;
  let t13;
  if ($[12] !== commitSearch || $[13] !== search || $[14] !== setMapCenter || $[15] !== setMapZoom || $[16] !== setSearchQuery) {
    t13 = item => {
      setInputValue(item.name);
      setSearchQuery(item.name);
      search(item.name);
      commitSearch();
      setIsAutofillOpen(false);
      if (item.location) {
        setMapCenter(item.location);
        setMapZoom(15);
      }
    };
    $[12] = commitSearch;
    $[13] = search;
    $[14] = setMapCenter;
    $[15] = setMapZoom;
    $[16] = setSearchQuery;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const handleSelectSuggestion = t13;
  let t14;
  if ($[18] !== clearSearch) {
    t14 = () => {
      setInputValue("");
      setIsAutofillOpen(false);
      clearSearch();
    };
    $[18] = clearSearch;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const handleClear = t14;
  let t15;
  let t16;
  if ($[20] !== inputValue || $[21] !== search || $[22] !== searchQuery) {
    t15 = () => {
      const timeoutId = setTimeout(() => {
        if (inputValue !== searchQuery) {
          search(inputValue);
        }
      }, 300);
      return () => clearTimeout(timeoutId);
    };
    t16 = [inputValue, searchQuery, search];
    $[20] = inputValue;
    $[21] = search;
    $[22] = searchQuery;
    $[23] = t15;
    $[24] = t16;
  } else {
    t15 = $[23];
    t16 = $[24];
  }
  useEffect(t15, t16);
  const t17 = `relative ${className}`;
  let t18;
  if ($[25] !== id) {
    t18 = <label htmlFor={id} className="sr-only">Search</label>;
    $[25] = id;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  const t19 = `w-full px-4 py-3 pr-12 pl-4 text-lg lg:h-12.5 h-11 font-semibold placeholder:text-[#757575] text-gray-900 bg-white border border-[#dddddd] 
              shadow-sm focus:outline-none ${isAutofillOpen ? "rounded-t-[10px] border-b-0" : "rounded-[10px] focus:ring-1 focus:ring-[#00EAFD]"} ${serchInputClass}`;
  let t20;
  if ($[27] !== handleFocus || $[28] !== handleInputChange || $[29] !== id || $[30] !== inputValue || $[31] !== isLoading || $[32] !== placeholder || $[33] !== t19) {
    t20 = <input id={id} type="text" value={inputValue} onChange={handleInputChange} onFocus={handleFocus} placeholder={placeholder} className={t19} disabled={isLoading} autoComplete="off" />;
    $[27] = handleFocus;
    $[28] = handleInputChange;
    $[29] = id;
    $[30] = inputValue;
    $[31] = isLoading;
    $[32] = placeholder;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== handleClear || $[36] !== inputValue || $[37] !== isLoading || $[38] !== searchClass) {
    t21 = inputValue ? <button type="button" onClick={handleClear} className={`absolute right-4 top-1/2 cursor-pointer transform -translate-y-1/2 hover:text-gray-600 ${searchClass}`} aria-label="Clear search"><svg className="w-5 h-5 text-[#A8A8A8]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg></button> : <div className={`absolute right-4 top-1/2 transform -translate-y-1/2 ${searchClass}`}><svg className={`w-5 h-5 ${isLoading ? "text-blue-500 animate-spin" : "text-[#A8A8A8]"}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">{isLoading ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /> : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />}</svg></div>;
    $[35] = handleClear;
    $[36] = inputValue;
    $[37] = isLoading;
    $[38] = searchClass;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t18 || $[41] !== t20 || $[42] !== t21) {
    t22 = <div className="relative flex items-center">{t18}{t20}{t21}</div>;
    $[40] = t18;
    $[41] = t20;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== filterMarkers || $[45] !== filters || $[46] !== handleSelectSuggestion || $[47] !== initialMarkers || $[48] !== inputValue || $[49] !== isAutofillOpen) {
    t23 = <SearchAutofill query={inputValue} items={initialMarkers} filters={filters} filterMarkers={filterMarkers} onSelect={handleSelectSuggestion} isOpen={isAutofillOpen} />;
    $[44] = filterMarkers;
    $[45] = filters;
    $[46] = handleSelectSuggestion;
    $[47] = initialMarkers;
    $[48] = inputValue;
    $[49] = isAutofillOpen;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== handleSubmit || $[52] !== t17 || $[53] !== t22 || $[54] !== t23) {
    t24 = <form onSubmit={handleSubmit} className={t17} ref={containerRef}>{t22}{t23}</form>;
    $[51] = handleSubmit;
    $[52] = t17;
    $[53] = t22;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  return t24;
}